import React, { useMemo } from 'react';
import CircleNumber from '../CircleNumber/CircleNumber';

interface StepNumberProps {
	number: number;
	currentNumber: number;
	stepText: string;
	disabled?: boolean;
}

const StepNumber: React.FC<StepNumberProps> = ({
	number,
	currentNumber,
	stepText,
	disabled = false
}) => {
	const variant = useMemo(() => {
		if (disabled) {
			return 'disabled';
		}
		if (currentNumber === number) {
			return 'filled';
		}
		if (currentNumber > number) {
			return 'outlined';
		}
		return 'gray';
	}, [currentNumber, disabled, number]);

	const classList = useMemo(() => {
		if (disabled) {
			return 'text-dm-grey';
		}
		if (currentNumber === number) {
			return 'text-orange';
		}
		if (currentNumber > number) {
			return 'text-dm-pure-white';
		}
		return 'text-dm-mid-grey';
	}, [currentNumber, disabled, number]);

	return (
		<>
			<div className="h-5 w-5 text-xs">
				<CircleNumber number={number} variant={variant} />
			</div>
			<span className={`text-sm lg:text-lg ${classList}`}>
				{stepText}
			</span>
		</>
	);
};

export default StepNumber;
